export class InitPaymentRequest {
  constructor(
    public transactionId: string,
    public paymentProvider: string
  ) { }
}
